import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiXCircle, FiX } = FiIcons;

const Toast = ({ message, type, onClose }) => {
  const isSuccess = type === 'success';
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 50, scale: 0.9 }}
      transition={{ type: "spring", duration: 0.5 }}
      className="fixed bottom-6 right-6 z-50"
    >
      <div className={`flex items-center space-x-3 px-6 py-4 rounded-xl shadow-lg backdrop-blur-sm border ${
        isSuccess 
          ? 'bg-green-900/80 border-green-700/50 text-green-100' 
          : 'bg-red-900/80 border-red-700/50 text-red-100'
      }`}>
        <SafeIcon 
          icon={isSuccess ? FiCheckCircle : FiXCircle} 
          className={`w-5 h-5 ${isSuccess ? 'text-green-400' : 'text-red-400'}`} 
        />
        <span className="font-medium">{message}</span>
        <button
          onClick={onClose}
          className="p-1 hover:bg-black/20 rounded transition-colors"
        >
          <SafeIcon icon={FiX} className="w-4 h-4" />
        </button>
      </div>
    </motion.div>
  );
};

export default Toast;